module.exports = __webpack_public_path__ + "resources/img/solution_game_arrow_m.3062b193e7dbeeb730f9eb7611b68bc6.png";